export default __webpack_public_path__ + "static/media/1128040325510222.58a2e363.jpg";